import React, { PureComponent } from 'react';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button } from 'formlabs-web-components/Link';
import { withTranslation } from 'react-i18next';

import './Blog.module.css';
const BlogPagination = DisplayComponent(
  class BlogPagination extends PureComponent {
    render() {
      const { page, hasNext, hasPrev, t } = this.props;
      let prev = parseInt(page, 10) - 1;
      const next = parseInt(page, 10) + 1;

      return (
        <div styleName="pagination-wrapper">
          {hasPrev && (
            <Button
              color="light"
              rel="prev"
              url={`${prev > 0 ? '?page=' + prev : ''}`}
            >
              <i className="fl-arrow-left" /> {t('Previous')}
            </Button>
          )}
          {hasNext && (
            <Button color="light" rel="next" url={`?page=${next}`}>
              {t('Next')} <i className="fl-arrow-right" />
            </Button>
          )}
        </div>
      );
    }
  }
);

BlogPagination.propTypes = {};

export default withTranslation()(BlogPagination);
